import { Box } from '@mui/material';
import { styled } from '@mui/system';
import Button from '@mui/material/Button';

export const Wrapper = styled(Box)`
  position: relative;
`;

export const Backdrop = styled(Box)`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1;
  display: grid;
  align-items: center;
  justify-content: center;
`;

export const PreviewImage = styled('img')`
  opacity: 0.5;
`;

export const DeleteButton = styled(Button)`
  position: absolute;
  top: 0;
  right: 0;
  width: 32px;
  height: 32px;
  border-radius: 4px;

  :hover {
    background: transparent;
  }
`;
